import { render, staticRenderFns } from "./OptionsTab.vue?vue&type=template&id=35be381d&scoped=true&"
import script from "./OptionsTab.vue?vue&type=script&lang=js&"
export * from "./OptionsTab.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTab.vue?vue&type=style&index=0&id=35be381d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be381d",
  null
  
)

export default component.exports